<template>
  <div id="coordinator-designation">
    <h4 class="sub-title">Coordinator Designation</h4>
    <div id="designation" class="dropdown">
      <label>Type of Coordinator:</label>
      <br />
      <b-form-select name="designation" v-model="designation" required>
        <option disabled value>Select a Coordinator Type</option>
        <option value="Regular">Regular</option>
        <option value="Advanced">Advanced</option>
        <option value="Coordinator">Coordinator</option>
      </b-form-select>
    </div>
    <div id="trainer" class="dropdown">
      <label>Linked Trainer:</label>
      <br />
      <b-form-select name="trainer" v-model="trainer_uuid" required>
        <option value="">No Linked Trainer</option>
        <option v-for="(trainer, i) in trainers" :key="i" :value="trainer.uuid">
          {{ trainer.first_name }} {{ trainer.last_name }}
        </option>
      </b-form-select>
    </div>
  </div>
</template>

<script>
import Options from "./Options.vue";
import CoordinatorService from "../services/CoordinatorService";
import { mapGetters, mapActions } from "vuex";

export default {
  components: { Options },
  name: "CoordinatorDesignation",
  props: [],
  data: {
    trainer_uuid: "",
  },
  computed: {
    designation: {
      get() {
        return this.$store.state.coordinators.coordinator.designation;
      },
      set(val) {
        this.$store.commit("coordinators/designation", val);
      },
    },
    trainer_uuid: {
      get() {
        return this.$store.state.coordinators.coordinator.trainer_uuid;
      },
      set(val) {
        this.$store.commit("coordinators/trainer_uuid", val);
      },
    },
    trainers: {
      get() {
        console.log(this.$store.state.coordinators.coordinatorTrainers);
        return this.$store.state.coordinators.coordinatorTrainers;
      },
    },
  },
  methods: {
    ...mapActions({
      GET_COORDINATOR_TRAINERS: "coordinators/GET_COORDINATOR_TRAINERS",
    }),
  },
  async created() {
    await this.GET_COORDINATOR_TRAINERS();
  },
};
</script>
